<div class="tracking-page">
  @if (bookingId === null || bookingDetail === null) {
    <div class="no-data-found">
      <rental-no-data-found></rental-no-data-found>
    </div>
  } @else {
    <figure class="brand">
      <img [src]="assests.logo" alt="Esqyre Logo" />
    </figure>

    <aside
      #sheet
      class="booking-panel"
      [class.expanded]="sheetExpanded"
      [class.dragging]="isSheetDragging"
      [style.transform]="sheetTransform"
      (pointerdown)="onSheetPointerDown($event)"
      (pointermove)="onSheetPointerMove($event)"
      (pointerup)="onSheetPointerUp($event)"
      (pointercancel)="onSheetPointerUp($event)">
      <div class="sheet-header">
        <span class="sheet-grabber" aria-hidden="true"></span>

        @if (bookingDetail && bookingDetail.orderStatus && isTripActive) {
          <h1 class="status">
            {{ trackingStatusLabel }}
          </h1>

          @if(bookingDetail.orderStatus === RhRideStatus.DRIVER_ASSIGNED || bookingDetail.orderStatus === RhRideStatus.START_RIDE || bookingDetail.orderStatus === RhRideStatus.RIDE_STARTED) {
            <h1 class="tracking-eta">{{ trackingEtaText }}</h1>
          }
        }

        @if (isTripActive && timerText) {
          <h1
            class="status arrival-timer"
            [class.waiting]="timerMode === 'pickup-waiting' || timerMode === 'dropoff-waiting'"
            [class.grace]="timerMode === 'pickup-grace' || timerMode === 'dropoff-grace'"
            [class.dropoff]="timerMode === 'dropoff-grace' || timerMode === 'dropoff-waiting'"
            [class.completed-wait]="timerMode === 'completed-wait'">
            {{ timerText }}
          </h1>
        }

        @if (bookingDetail && bookingDetail.orderStatus && isTripActive && trackingStatusSubtext) {
          <h1 class="sub-text">
            {{ trackingStatusSubtext }}
          </h1>
        }
      </div>

      <div class="panel-body" #panelBody>
        @if (bookingDetail) {
          @if (isTripActive) {
            <ul class="route">
              <li class="route-stop pickup">
                <figure><img [src]="assests.locationIcon" alt=""></figure>
                <div class="route-text">
                  <span class="route-label">{{ "PickupLocation" | translate }}</span>
                  <p class="route-address">{{ pickupAddress }}</p>
                </div>
              </li>

              <li class="route-stop dropoff" #peekAnchor>
                <figure><img [src]="assests.locationIcon" alt=""></figure>
                <div class="route-text">
                  <span class="route-label">{{ "DropOffLocation" | translate }}</span>
                  <p class="route-address">{{ dropOffAddress }}</p>
                </div>
              </li>
            </ul>

            @if (bookingDetail.driverId) {
              <div class="driver-card">
                <figure class="driver-avatar">
                  @if (bookingDetail.driverId.image) {
                    <img [src]="bookingDetail.driverId.image" alt="Chauffeur" />
                  } @else {
                    <img class="driver-icon" [src]="assests.UsersIcon" alt="Chauffeur" />
                  }
                </figure>

                <div class="driver-info">
                  <h2 class="driver-name">
                    {{ bookingDetail.driverId.firstName ? bookingDetail.driverId.firstName : "" }}
                    {{ bookingDetail.driverId.lastName ? bookingDetail.driverId.lastName : "" }}
                  </h2>

                  <div class="driver-meta">
                    @if (driverRatingLabel) {
                      <span class="driver-rating">★ {{ driverRatingLabel }}</span>
                    }
                    @if (vehicleLabel) {
                      <span class="driver-vehicle">{{ vehicleLabel }}</span>
                    }
                  </div>

                  <!-- @if (bookingDetail.driverId.phoneNo && platformServiceType === PANEL_SERVICE_TYPE.SELF_CHAUFFEUR) {
                    <button type="button" class="driver-phone" (click)="copyPhoneNo()">
                      <span>
                        {{ bookingDetail.driverId.dialCode ? bookingDetail.driverId.dialCode : "" }}
                        {{ bookingDetail.driverId.phoneNo }}
                      </span>
                      <img class="copy-icon" [src]="assests.copyIcon" alt="Copy phone number"/>
                    </button>
                  } -->
                </div>

                @if (bookingDetail.driverId.phoneNo) {
                  <a
                    class="call-btn"
                    [matTooltip]="(bookingDetail.driverId.dialCode ? bookingDetail.driverId.dialCode + '-' : '') + bookingDetail.driverId.phoneNo"
                    [href]="driverPhoneHref"
                    aria-label="Call chauffeur">
                    <img [src]="assests.phoneIcon" alt="" />
                  </a>
                }
              </div>
            }
          } @else {
            <p class="trip-unavailable">
              {{ "RideNoLongerAvailable" | translate }}
            </p>
          }
        }
      </div>
    </aside>

    <main class="map-area">
      <div id="map"></div>
    </main>
  }
</div>
